<template>
    <div class="p-grid">
        <Toast />

        <div class="p-col-12">
            <div class="card">
                <h5>{{ $t('Chodan.list.Chodan List') }}</h5>
                <br />
                <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('Chodan.list.No')" style="min-width: 4rem">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            {{(index + 1) }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('Chodan.list.Name')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Name</span>
                            {{ data.coin_package_name }}
                        </template>
                    </Column>
                    <Column :header="$t('Chodan.list.Coins')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Coins</span>
                            {{ data.coin_count }}
                        </template>
                    </Column>
                    <Column :header="$t('Chodan.list.GoogleCodes')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Google Code</span>
                            {{ data.play_store_product_id }}
                        </template>
                    </Column>
                    <Column :header="$t('Chodan.list.AppleCode')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Apple Code</span>
                            {{ data.app_store_product_id }}
                        </template>
                    </Column>

                    <Column :header="$t('Chodan.list.Status')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Active / Inactive</span>
                            <InputSwitch v-model="data.status" trueValue="active" @change="switchValue(data.id, data.status)" />
                            <!-- {{ data.status }} -->
                        </template>
                    </Column>

                    <Column :header="$t('Chodan.list.Action')" style="min-width: 6rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <!-- <router-link :to="'/ViewRecruiter/'"
                                    ><Button label="info" class="p-button2"><i class="pi pi-eye p-mr-2"></i> </Button>
                                </router-link> -->
                                <router-link :to="'/PaidFeatureManagement/ChodanCoin/EditChodanCoin/'+ data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-user-edit p-mr-2"></i> </Button>
                                </router-link>
                                <!-- <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" /> -->
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';/
// import {AdminService} from '@/service/API/AdminService';
// import axios from 'axios';
import CoinService from '../../../service/API/CoinService';
// import { AdminService } from '@/service/API/AdminService.js';
import axios from 'axios';
export default {
    data() {
        return {
            loading1: false,
            products: null,
            expandedRows: [],
            results: [],

            dropdownItem: null,
            error: {},
            //params for list
            name: '',
            email: '',
            phone_number: '',
            user: {
                menus: [],
            },
        };
    },
    // customerService: null,
    AdminService: null,
    created() {
        this.coinService = new CoinService();
    },
    mounted() {
        this.getCClist();
    },
    watch: {},
    methods: {
        getCClist() {
            this.loading1 = true;
            this.coinService
                .getCoinList()
                .then((res) => {
                    this.results = res.data.result;
                    // this.totalrecords = res.data.total_records;
                    // this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch((err) => console.log(err));
        },
        switchValue(ids, switchstatus) {
            console.log(ids, switchstatus);
            var self = this;
            axios({ method: 'post', url: '/api/v1/admin/chodan-coin/change-status', data: { coin_id: ids, status: switchstatus === false ? 'inactive' : 'active' } }).then(function (response) {
                // this.$router.push({ name: 'Banner Management' });
                self.$toast.add({ severity: 'info', summary: '확인.', detail: '초코 상태가 변경되었습니다.', life: 3000 });
                console.log(response);
            });
        },

        resetNotice() {
            this.notice_title = '';
            this.start_date = '';
            this.end_date = '';
            this.writer_name = '';
            this.sortByValue = 'id';
            this.sortOrderValue = 'desc';
            this.newnoticelist(); // for refresh the table data
        },

        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}
.p-fluid {
    .p-button {
        width: auto;
    }
}
</style>